import { useTranslation } from 'react-i18next';
import ChatBubble from '../../../components/Chat/Chat';
import mascot from '../../../assets/kitoBuddy/Celebration.png';
import CustomButton from '../../../components/Inputs/CustomButton';

export default function Congratulations({ title, CTA, path }) {
  const { t } = useTranslation();
  const handleNavigate = () => {
    window.location.href = t(path);
  };
  return (
    <div className="congrats">
      <ChatBubble img={mascot} text={t(title)} />
      <CustomButton label={t(CTA)} className="congrats__button" onClick={handleNavigate} />
    </div>
  );
}
